export enum AccountingConditionJoinOperator {
AND,
OR,
}
